import { CaretLeftIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowLeftSmall = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <CaretLeftIcon color={stroke || fill} {...rest} size={Sizes[size]} />;
};

ArrowLeftSmall.displayName = 'ArrowLeftSmall';
